import {stage} from "../../../../config/stage";

type BillingApiEndpointConfig = {
    endpoint: string;
    region: string;
    apiKey: string;
};

// flexinet-billing-api
const appsync: Record<string, BillingApiEndpointConfig> = {
    prod: {
        endpoint: 'https://awqbc7agkrdxza4di3ggk2tsnq.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    test: {
        endpoint: 'https://jwbq5ckinrd2bctdhu47c3jjva.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    dev: {
        endpoint: 'https://43ruvo3zkbf4jkj7zpsisoubmi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
    ide: {
        endpoint: 'https://43ruvo3zkbf4jkj7zpsisoubmi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        apiKey: '',
    },
};

const fallback: BillingApiEndpointConfig = {
    endpoint: '',
    region: 'us-west-2',
    apiKey: '',
};

const resolved = appsync[stage as string];
if (!resolved) {
    console.warn(
        `[billingApiConfig] Unknown stage "${String(stage)}" — falling back to empty endpoint. ` +
        `Set VITE_STAGE to one of: ${Object.keys(appsync).join(', ')}.`
    );
}

export const billingApiConfig: BillingApiEndpointConfig = resolved ?? fallback;
